const actions = {
  SET_INSTITUTION_ITEM: "SET_INSTITUTION_ITEM",
  SET_INSTITUTION_ITEM_VALUE: "SET_INSTITUTION_ITEM_VALUE",
  INSTITUTION_IS_SUBMITTING: "INSTITUTION_IS_SUBMITTING",
  INSTITUTION_CREATE_FAILED: "INSTITUTION_CREATE_FAILED",

  SET_SERVICE_INSTITUTION_ITEM: "SET_SERVICE_INSTITUTION_ITEM",
  SET_PERSONAL_INSTITUTION_ITEM: "SET_PERSONAL_INSTITUTION_ITEM",
  INSTITUTION_BINDINGS_LOADING: "INSTITUTION_BINDINGS_LOADING",
  ADMIN_INSTITUTION_SUBMITTING: "ADMIN_INSTITUTION_SUBMITTING",
  PERSONAL_INSTITUTION_PROCESS_FAILED: "PERSONAL_INSTITUTION_PROCESS_FAILED",
  SERVICE_INSTITUTION_PROCESS_FAILED: "SERVICE_INSTITUTION_PROCESS_FAILED",
  
  LOAD_INSTITUTIONS_BY_LEVEL: "LOAD_INSTITUTIONS_BY_LEVEL",
  INSTITUTIONS_BY_LEVEL_ARE_LOADING: "INSTITUTIONS_BY_LEVEL_ARE_LOADING",

  SET_INSTITUTION_PARENT: "SET_INSTITUTION_PARENT",
  PARENT_BY_PARENT_IS_LOADING: "PARENT_BY_PARENT_IS_LOADING",

  ATTACH_FILE: "ATTACH_FILE",
  SET_NEW_INSTITUTION_DETAIL: "SET_NEW_INSTITUTION_DETAIL",

  LOAD_INSTITUTIONS_BY_LEVEL_EXEPT_LAST: "LOAD_INSTITUTIONS_BY_LEVEL_EXEPT_LAST",
  INSTITUTIONS_BY_LEVEL_EXEPT_LAST_ARE_LOADING: "INSTITUTIONS_BY_LEVEL_EXEPT_LAST_ARE_LOADING",

    SET_INSTITUTION_PARENT_FOR_SUBORDINATE: "SET_INSTITUTION_PARENT_FOR_SUBORDINATE"

};
export default actions;
 


// WEBPACK FOOTER //
// ./src/redux/constants/admin/institutions.js